import {
  ChartColumn,
  CircleDollarSign,
  GraduationCap,
  Newspaper,
  Palette,
  TabletSmartphone,
  Truck,
} from "lucide-react";
import React from "react";

import { IgPaper, IgTypography } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";
import { theme } from "@src/theme";
import {
  analyzingResults,
  contentTesting,
  introductionToIntelligems,
  personalizationsGettingStarted,
  priceIntegrationDocs,
  shippingTesting,
} from "@src/utils/linkSheet";
import { openNewTab } from "@src/utils/openNewTab";

const articleList = [
  {
    title: "Introduction to Intelligems",
    link: introductionToIntelligems,
    icon: <GraduationCap size={35} />,
    description:
      "See what features and services Intelligems offers to help your business maximize profitability.",
  },
  {
    title: "Price Testing",
    link: priceIntegrationDocs,
    icon: <CircleDollarSign size={35} />,
    description:
      "Create real-time A/B tests for maximum profit, revenue, and conversion boosts.",
  },
  {
    title: "Shipping Testing",
    link: shippingTesting,
    icon: <Truck size={35} />,
    description: "Easily design personalized multi-group shipping rate tests.",
  },
  {
    title: "Content Testing",
    link: contentTesting,
    icon: <Newspaper size={35} />,
    description:
      "Content tests tailored to Shopify merchants. Test landing pages, imagery, copy, themes, and more.",
  },
  {
    title: "Personalizations",
    link: personalizationsGettingStarted,
    icon: <TabletSmartphone size={35} />,
    description:
      "Custom tailor every visitor’s experience with targeted offers, layouts, branding and copy.",
  },
  {
    title: "Analyzing Results",
    link: analyzingResults,
    icon: <ChartColumn size={35} />,
    description:
      "Analytics overview, data export, and more. Make data-driven decisions with Intelligems.",
  },
];

export const Resources = () => {
  return (
    <Grid container direction={"column"} rowSpacing={4}>
      <Grid item>
        <IgTypography variant={"h2"} fontWeight={"fontWeightMedium"}>
          Explore Our Library of Resources
        </IgTypography>
      </Grid>
      <Grid
        item
        container
        direction={"row"}
        columnSpacing={2}
        rowSpacing={2}
        justifyContent={"space-between"}
      >
        {articleList.map((article, index) => (
          <Grid item xs={4} key={`article-${index}`}>
            <IgPaper
              onClick={() => {
                openNewTab(article.link, article.title);
              }}
              sx={{
                padding: "15px 20px",
                minHeight: "100px",
                "&:hover": {
                  cursor: "pointer",
                  border: `1px solid ${theme.igBorders.core.hover}`,
                },
              }}
            >
              <Grid
                key={article.title}
                container
                item
                direction={"row"}
                wrap={"nowrap"}
                columnSpacing={4}
              >
                <Grid item>{article.icon}</Grid>
                <Grid item container direction={"column"}>
                  <Grid item>
                    <IgTypography
                      variant={"h3"}
                      // fontWeight={"fontWeightMedium"}
                    >
                      {article.title}
                    </IgTypography>
                  </Grid>
                  <Grid item>
                    <IgTypography color={theme.palette.text.secondary}>
                      {article.description}
                    </IgTypography>
                  </Grid>
                </Grid>
              </Grid>
            </IgPaper>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};
